// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui';
import 'lib-flexible';
import apiFun from './api/api.js';
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';

Vue.use(VideoPlayer)
// 这个是为了兼容 m3u8
const hls = require('videojs-contrib-hls')
Vue.use(hls)

Vue.prototype.$apiFun = apiFun;//请求接口api

Vue.use(Element);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js